import { useTranslation } from '../../../hooks/useNavConfig';
import { BreezeCopilotIcon } from '../icons/BreezeCopilotIcon';
import CommerceIcon from '../../icons/CommerceIcon';
import ExternalLink from '../../icons/ExternalLink';
import MarketplaceIcon from '../../icons/NewMarketplaceIcon';
import SettingsIcon from '../../icons/NewSettingsIcon';
import NotificationsIcon from '../../icons/NotificationsIcon';
import UpgradeIcon from '../../icons/UpgradeIcon';
import UpgradeArrowIcon from '../../icons/UpgradeArrow';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export let ICON_NAMES;
(function (ICON_NAMES) {
  ICON_NAMES["UPGRADE"] = "upgrade";
  ICON_NAMES["UPGRADE_ARROW"] = "upgrade-arrow";
  ICON_NAMES["PAYMENTS"] = "payments";
  ICON_NAMES["SETTINGS"] = "settings";
  ICON_NAMES["NOTIFICATIONS"] = "notifications";
  ICON_NAMES["EXTERNAL_LINK"] = "externalLink";
  ICON_NAMES["BREEZE_COPILOT"] = "breeze-copilot";
  ICON_NAMES["MARKETPLACE"] = "marketplace";
})(ICON_NAMES || (ICON_NAMES = {}));
const ICONS = {
  [ICON_NAMES.SETTINGS]: SettingsIcon,
  [ICON_NAMES.UPGRADE]: UpgradeIcon,
  [ICON_NAMES.UPGRADE_ARROW]: UpgradeArrowIcon,
  [ICON_NAMES.PAYMENTS]: CommerceIcon,
  [ICON_NAMES.NOTIFICATIONS]: NotificationsIcon,
  [ICON_NAMES.BREEZE_COPILOT]: BreezeCopilotIcon,
  [ICON_NAMES.EXTERNAL_LINK]: ExternalLink,
  [ICON_NAMES.MARKETPLACE]: MarketplaceIcon
};
export function GlobalToolbarIcon(props) {
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const iconName = props.name;
  const Icon = ICONS[iconName];
  const title = props.titleKey ? t(props.titleKey) : '';
  if (!Icon) {
    throw Error(`${props.name} is not a Global toolbar icon`);
  }
  return /*#__PURE__*/_jsx(Icon, {
    title: title,
    width: "16px",
    height: "16px",
    fill: theme.color['global-shell-icon-nav-item-default']
  });
}